import { actions as formActions, getModel } from 'react-redux-form'
import { t } from 'ttag'
import isObject from 'lodash/isObject'

import { findFilterById, findFilterByType } from './search/filters'

import { browserHistory } from '../util/browserHistory'
import * as h2Api from '../h2Api'

import 'url-search-params-polyfill'


import isEqual from 'lodash/isEqual'

export const SEARCH_AUTO_SUGGEST_BY_TERM = 'SEARCH_AUTO_SUGGEST_BY_TERM'
export const SEARCH_ITEMS = 'SEARCH_ITEMS'

export const SEARCH_SUGGEST_OCCUPATION = 'SEARCH_SUGGEST_OCCUPATION'
export const SEARCH_SUGGEST_MAJOR = 'SEARCH_SUGGEST_MAJOR'
export const SEARCH_SUGGEST_COLLEGE = 'SEARCH_SUGGEST_COLLEGE'

export const SEARCH_RESULTS_INIT = 'SEARCH_RESULTS_INIT'
export const SEARCH_RESULTS_APPEND = 'SEARCH_RESULTS_APPEND'
export const SEARCH_RESULTS_CLEAR = 'SEARCH_RESULTS_CLEAR'
export const ADD_SEARCH_ITEMS = 'ADD_SEARCH_ITEMS'

export const initSearchResults = items => {
  return { type: SEARCH_RESULTS_INIT, items }
}
export const appendSearchResults = items => {
  return { type: SEARCH_RESULTS_APPEND, items }
}
export const clearSearchResults = items => {
  return { type: SEARCH_RESULTS_CLEAR, items }
}

export const suggestCollegesFromInput = term => {
  const encodedTerm = encodeURIComponent(term)

  return h2Api.get(`/api/v1/search/suggest/colleges/${encodedTerm}`)({
    type: SEARCH_SUGGEST_COLLEGE
  })
}

export const suggestOccupationsFromInput = term => {
  const encodedTerm = encodeURIComponent(term)

  return h2Api.get(`/api/v1/search/suggest/occupations/${encodedTerm}`)({
    type: SEARCH_SUGGEST_OCCUPATION
  })
}

export const suggestMajorsFromInput = term => {
  const encodedTerm = encodeURIComponent(term)

  return h2Api.get(`/api/v1/search/suggest/majors/${encodedTerm}`)({
    type: SEARCH_SUGGEST_MAJOR
  })
}

export const suggestItems = term => {
  


  const encodedTerm = encodeURIComponent(term)


  return h2Api.get(`/api/v1/search/suggest/${encodedTerm}`)({
    type: SEARCH_AUTO_SUGGEST_BY_TERM
  })
}

export const search = term => form => dispatch => {
  const { types } = form
  const data = {
    term,
    types,
    filters: form
  }

  return dispatch(h2Api.post(`/api/v1/search/all`, data)({ type: SEARCH_ITEMS })).then(
    v => {
      dispatch(initSearchResults(v.results))
    }
  )
}

export const loadSubsequentSearchResults = (term, form) => (
  startIdx,
  endIdx
) => dispatch => {
  

  const { types } = form
  const data = {
    term,
    types,
    start: startIdx,
    end: endIdx,
    filters: form
  }

  return dispatch(
    h2Api.post(`/api/v1/search/all`, data)({ type: ADD_SEARCH_ITEMS })
  ).then(v => {

    dispatch(appendSearchResults(v.results))
  })
}

export const guessSearchResultType = (resultType, additionalMeta) => {
  const jobOrderTypeTitle = () => {
    if (additionalMeta) {
      if (additionalMeta.internship) {
        return t`Internship`
      }

      if (additionalMeta.apprenticeship) {
        return t`Apprenticeship`
      }
    }

    return t`Job Opening`
  }

  switch (resultType) {
    case 'occupation':
      return {
        className: 'occupation',
        iconClassName: `fal fa-briefcase`,
        title: t`Occupation`
      }
    case 'joborders':
      return {
        className: 'jobopening',
        iconClassName: `h2-jobopening`,
        title: jobOrderTypeTitle()
      }
    case 'profiles':
      return {
        className: 'profile',
        iconClassName: `fal fa-briefcase`,
        title: t`Programs`
      }
    case 'moc':
      return {
        className: 'military',
        iconClassName: `h2-military`,
        title: t`Military Occupation`
      }
    default:
      return {
        className: resultType.toLowerCase(),
        iconClassName: `h2-${resultType.toLowerCase()}`,
        title: resultType.toUpperCase().slice(0, 1) + resultType.toLowerCase().slice(1)
      }
  }
}

export const extractFilters = (modelName, location) => (dispatch, getState) => {
  

  const model = getModel(getState(), modelName)

  const params = new URLSearchParams(location?.search)

  for (const [key, value] of params.entries()) {

  }

  const q = params.has('q') ? { term_filter: params.get('q') } : {}
  const propsToSetForm = {}
  const propsToReturn = {}


  for (const propKey of params.keys()) {


    if (propKey === 'ownership') {

    }

    if (propKey === 'assessment_filter' || propKey === 'job_listing_type') {
      const newV = {}

      params.getAll(propKey).forEach(v2 => {
        newV[v2] = true
      })
      propsToSetForm[propKey] = newV
    } else {
      if (propKey === 'ownership') {

      }

      propsToSetForm[propKey] = params.getAll(propKey)
    }

    if (propKey === 'distance') {
      const parts = params.get(propKey)
      const [zipCode = null, radius = 25] = parts?.split(',')

      propsToReturn[propKey] = `${zipCode},${radius}`
      propsToSetForm[propKey] = { zipCode, radius }
    } else {
      propsToReturn[propKey] = params.getAll(propKey)
    }
  }

  //Some Keys in the model don't need to be flattened here, so we'll ignore them
  const ignorableKeys = ['distance']

  Object.keys(model).forEach(k2 => {

    const itm = model[k2]

    if (!Array.isArray(itm) && isObject(itm) && !ignorableKeys.includes(k2)) {
      propsToReturn[k2] = Object.keys(itm).flatMap(k3 => {
        if (itm[k3]) {
          return [k3]
        }

        return []
      })

    } else {
      //propsToReturn.append(k, k2)
    }
  })

  const newModel = {
    ...model,
    ...q,
    ...propsToSetForm
  }
  const newReturnModel = {
    ...model,
    ...q,
    ...propsToReturn
  }



  if (Object.keys(newModel).length > 0) {
    dispatch(formActions.reset(modelName))

    dispatch(formActions.change(modelName, newModel))
  } else {
    dispatch(formActions.reset(modelName))

  }

  /*
   *

   *

   *

   */
  return newReturnModel
}

/**
 * Post processing of server response because some fields need more info from the server beyond what the queryString
 * provides. For example, selectize components with autocomplete need the choice value in addition to the id provided.
 * @param response
 * @param searchFilterFormName
 * @returns {(function(*): void)|*}
 */
export const setFormFromResponse = (response, searchFilterFormName) => dispatch => {
  


  response?.filters.forEach(filter => {

    const filterHandler = findFilterByType(filter)

    dispatch(filterHandler.setFormValue(searchFilterFormName))
  })
}

export const clearQueryParams = (filter, searchFilterFormName) => dispatch => {
  



  if (searchFilterFormName) {


  }

  const url = window.location.pathname
  const params = new URLSearchParams()
  const { term_filter, ...filters } = filter


  if (term_filter) {
    params.set('q', term_filter)
  }

  //A bit of a hack, but the select doesn't reset well without having the default by US
  if ('state' in filters) {
    params.set('state', 'US')
  }

  const qs = params.toString()

  browserHistory.replace(`${url}${qs ? `?${qs}` : ``}`)
}

/**
 * This method will attempt to set a query parameter with the offset in the list so the infinite scroll can
 * reset itself on the back button
 *
 * @param location
 * @returns {(function(*=): void)|*}
 */
export const updateUrlWithFirstResultInWindow = location => idx => {
  


  /*
   * const params = new URLSearchParams(location?.search)
   * params.set("first", idx)
   * console.trace()
   */

  /*
   * if(idx > 0)
   *   browserHistory.replace(`${window.location.pathname}?${params.toString()}`)
   */
}

//Query parameters that we don't want to do any processing with in the test to see if we need to reload
const ignorableKeys = ['comp', 'first']

export const queryStringDiffRequiresReload = (queryString1, queryString2) => {
  


  //    console("Received", queryString1, "comparing to", queryString2)
  if (isEqual(queryString1, queryString2)) {


    return false
  }

  if (!!queryString1 || !!queryString2) {


    return true
  }

  //They won't be equal since the previous lines checks that.
  if (queryString1.length === 0 || queryString2.length === 0) {


    return true
  }

  const qs1 = new URLSearchParams(queryString1)
  const qs2 = new URLSearchParams(queryString2)

  ignorableKeys.forEach(k => {
    //

    qs1.delete(k)
    qs2.delete(k)
  })

  const allKeys = [...new Set([...qs1.keys(), ...qs2.keys()])]
  //

  const matches = allKeys.every(k => {
    if (qs1.has(k) && qs2.has(k)) {
      const allQs2Vals = qs1.getAll(k).sort()
      const allQs1Vals = qs2.getAll(k).sort()

      //

      return (
        allQs1Vals.length === allQs2Vals.length &&
        allQs1Vals.every((v, i) => v === allQs2Vals[i])
      )
      //return allQs1Vals == allQs2Vals;
    }

    return false
  })


  return !matches
}

export const updateQueryParams = (form, filtersFromResponse) => {
  

  const url = window.location.pathname
  const { term_filter, q, ...filters } = form

  const params = new URLSearchParams()

  if (term_filter) {
    params.set('q', term_filter)
  }

  Object.keys(filters).forEach(k => {
    const filterHelper = findFilterById(k, filtersFromResponse)


    if (ignorableKeys.includes(k)) {
      //do nothing
    } else {
      filterHelper.updateSearchParams(filters[k], k, params)
    }
  })
  const qs = params.toString()

  //const qs = (qParam ? [qParam, ...otherParams] : otherParams).join("&")
  browserHistory.replace(`${url}?${qs}`)
}
